import { messagingMethodsApi } from './messagingMethodsApi'
import {
  MessagingMethodsDTO,
  MessagingMethodsParams,
} from './messagingMethodsTypes'

async function fetchMessagingMethods(
  params: MessagingMethodsParams,
): Promise<{ methods: MessagingMethodsDTO[] }> {
  return messagingMethodsApi.fetchMessagingMethods(params)
}

export const messagingMethodsServices = {
  fetchMessagingMethods,
}
